import { observer } from 'mobx-react';
import React from 'react';
import { UserSystemRoleModelPermissionMap } from '../../../../service/systemRole/entity/actions/UserSystemRoleModelPermissionMap';
import { LearningAdminPage } from '../../../admin/page/learning/LearningAdminPage';
import { PageLoader } from '../../../design/page/PageLoader';
import { IPageWithLayoutProperties } from '../../../layout/page/IPageWithLayoutProperties';
import { LearningUserPage } from '../../../user/page/learning/LearningUserPage';

export const LearningEntryPage = observer(({ layoutDomain }: IPageWithLayoutProperties) => {
  const isLayoutReady = layoutDomain.ui.isBootLoading.value === false;
  const activeUser = layoutDomain.ui.activeUser.entity;
  const isRoleReady = isLayoutReady && Boolean(activeUser?.id) && Array.isArray(activeUser?.allowedPermissions);

  if (!isRoleReady) {
    return <PageLoader minHeight="100%" size={28} />;
  }

  const isAdmin = layoutDomain.userHaveAnyAccess([UserSystemRoleModelPermissionMap['global-allow-any']]);
  if (isAdmin) {
    return <LearningAdminPage layoutDomain={layoutDomain} />;
  }

  return <LearningUserPage layoutDomain={layoutDomain} />;
});
